import { env } from '@/utils/shared/env';

const BASE = env.VITE_BASE_URL_PATH || '/job-viewer';

export const Paths = {
    LOCAL_LOGIN: `${BASE}/login`,
    BASE: `${BASE}/`,
    RESTRICTED: `${BASE}/restricted`,
    NO_PERMISSIONS: `${BASE}/no-permissions`,
    JOBS: `${BASE}/jobs`,
    TASKS: `${BASE}/tasks`,
    ALL: '*',
} as const;

export const TITLE_MAP = {
    DEFAULT: 'Jobs Explorer',
    INSPECTOR: 'Job Inspector',
} as const;
